
































import { Component, Emit, Prop, Vue, Watch } from "vue-property-decorator";
import { mapState } from "vuex";
import ContentsStore from "@/store/contents";
import axios from "axios";
import { MattertagParams } from "@/interfaces/ContentsParams";
import {AppEvent, VueEventTypes} from "@/events/AppEvent";
import BgmCreditSnack from "@/components/atoms/BgmCreditSnack.vue";

@Component({
  components: {
    BgmCreditSnack
  },
  computed: {
    ...mapState('contents', ['tags']),
    ...mapState('bgm', ['isBgmPlaying'])
  }
})
export default class VrSpaceContents extends Vue {
  @Prop({ default: '' }) mpid!: string;
  @Prop({ default: false }) debug!: boolean;

  /* DOM Elements */
  public $vrSpace: HTMLIFrameElement;
  /* Private Member */
  // Matterport SDKオブジェクト
  private mpSdk: any;
  // MapState: tags
  private tags: MattertagParams[];
  private currentTag: MattertagParams = null;

  // BGMクレジットの表示・非表示トリガー
  private isBgmCredit: boolean = false;
  private isBgmOnce: boolean = false;


  get isSmp (): boolean {
    return this.$store.state.isSmp;
  }

  /**
   * BGM再生に伴ってBGMのクレジットを表示する
   */
  @Watch('isBgmPlaying')
  onChangeBgmPlaying (newValue: boolean, oldValue: boolean) {
    if (!this.isBgmOnce) {
      if (newValue) {
        this.isBgmOnce = true;
        this.isBgmCredit = true;
        // 5秒でクレジットを非表示にする
        setTimeout(() => {
          this.isBgmCredit = false;
        }, 8000);
      }
      else {
        this.isBgmCredit = false;
      }
    }
  }


  /* Lifecycle Hook */
  mounted (): void {
    this.$nextTick(() => {
      console.log('VR Space Mounted');
      this.$vrSpace = <HTMLIFrameElement> this.$refs.vrSpace;
      this.$vrSpace.src = `https://my.matterport.com/show/?m=${this.mpid}&play=1&qs=0&vr=0&lang=en&help=0&brand=0&hl=2`;
      this.$vrSpace.addEventListener('load', this.onVrSpaceLoaded);
    });
  }


  /* Event Handler */
  private onVrSpaceLoaded (): void {
    console.log('On VR Space Loaded');
    this.$vrSpace.removeEventListener('load', this.onVrSpaceLoaded);

    try {
      const showcase: any = window.MP_SDK.connect(
        document.getElementById('vr-space-iframe'),
        this.$store.state.matterport_sdk_key,
        '3.2'
      )
      .then( async (mpSdk) => {
        this.mpSdk = mpSdk;
        console.log('=========== SDK Load Success ============');
        console.dir(this.mpSdk);
        // コンテンツデータをロードする
        await this.loadContentsData();
        // Mattertagsの設定をする
        await this.setMattertags();

        // VRSpaceのロード表示後に実行する
        this.mpSdk.App.state.subscribe(async (appState) => {
          console.log('App State: ', appState);

          if (appState.phase === 'appphase.starting') {
            // アプリケーションのロード完了
            this.onLoadComplete();
          }

          if (appState.phase === 'appphase.playing') {
            /* テスト：Mattertagのクリック
            this.currentTag = this.tags[7];
            this.$emit(VueEventTypes.CLICK_MATTERTAG, this.currentTag);
             */
          }
        });
      })
      .catch((error) => {
        console.log(error);
      });
    }
    catch (error) {
      // ここでエラー表示
    }
  }


  private async loadContentsData (): Promise<any> {
    return new Promise((resolve, reject) => {
      const http = axios.create({
        baseURL: '/',
        headers: {
          'Cache-Control': 'no-cache',
        }
      });

      // コンテンツのデータをロードする
      http.get(this.$store.state.publicPath + '/data/contents.json')
        .then((response) => {
          console.log(response.data.mp_tags);
          const data: any = response.data;
          // MatterTagのデータをstoreにコミット
          this.$store.commit('contents/setTagData', data.mp_tags);
          resolve(0);
        })
        .catch((error) => {
          reject('load_contents_error');
        });
    });
  }

  private async setMattertags (): Promise<any> {
    try {
      const mattertagsData = await this.mpSdk.Mattertag.getData();
      console.log(mattertagsData);
      // Mattertagのラベルと色を変更してリセットする
      for (let i = 0; i < this.tags.length; i++) {
        const tag: MattertagParams = this.tags[i];
        await this.mpSdk.Mattertag.editColor(tag.sid, tag.color);
        await this.mpSdk.Mattertag.editBillboard(tag.sid, {
          description: '',
          label: tag.label,
          media: {src: '', type: 'mattertag.media.none'}
        });
      }

      this.mpSdk.on(this.mpSdk.Mattertag.Event.CLICK, sid => {
        this.tags.some(tag => {
          if (tag.sid === sid) {
            this.currentTag = tag;
            return true;
          }
        });
        // イベント発火と併せてクリックされたMattertagを渡す
        this.$emit(VueEventTypes.CLICK_MATTERTAG, this.currentTag);
      });

      return Promise.resolve(0);
    }
    catch (error) {
      return Promise.reject(error);
    }
  }

  @Emit(VueEventTypes.LOAD_COMPLETE)
  onLoadComplete (): void {};

}
